import * as React from "react";
const PRICING_TITLE = "Chemix Boost - Get more done with Chemix!";
const PRICING_DESCRIPTION = "Chemix Boost is an affordable subscription for serious students and teachers. "
    + "Get unlimited access to premium features, an expanded asset library, bigger Cloud storage and much more. "
    + "Available for individuals, teams and organisations.";
/**
 * Updates document title and meta description dynamically when the pricing route is active,
 * restoring the previous values on route change.
 */
export function usePricingSeo(isActive) {
    React.useEffect(() => {
        if (!isActive) {
            return;
        }
        const prevTitle = document.title;
        document.title = PRICING_TITLE;
        const metaDesc = document.querySelector('meta[name="description"]');
        const prevDesc = metaDesc ? metaDesc.getAttribute("content") : null;
        if (metaDesc) {
            metaDesc.setAttribute("content", PRICING_DESCRIPTION);
        }
        return () => {
            document.title = prevTitle;
            if (metaDesc && prevDesc) {
                metaDesc.setAttribute("content", prevDesc);
            }
        };
    }, [isActive]);
}
